import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { formatDate } from '../../../../utils/Utils';

// Mesmo padrão visual de CronStatusChip/SubscriptionStatusBadge (bolinha + texto).
const ORIGIN_CONFIG = {
  platform: { label: 'Plataforma', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
  own_connected: { label: 'Próprio conectado', bg: '#E8F5E9', border: '#C8E6C9', dot: '#2E7D32', text: '#2E7D32' },
  own_disconnected: { label: 'Próprio desconectado', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
};

/**
 * Formata uma data 'Y-m-d H:i:s' (fuso do servidor) usando formatDate() do projeto.
 * @param {string|null} dateStr
 * @returns {string}
 */
function fmtDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * OriginChip - Indicador da origem atual do envio de uma empresa (plataforma ou número
 * próprio, conectado/desconectado), com tooltip da última checagem quando disponível.
 * (Admin Geral > WhatsApp)
 * @param {Object} props
 * @param {string} props.origin - platform|own_connected|own_disconnected
 * @param {string|null} props.checkedAt
 */
function OriginChip({ origin, checkedAt }) {
  const cfg = ORIGIN_CONFIG[origin] || ORIGIN_CONFIG.platform;
  const chip = (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        width: 'fit-content',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: cfg.text, whiteSpace: 'nowrap' }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
  if (!checkedAt) return chip;
  return <Tooltip title={`Última checagem: ${fmtDate(checkedAt)}`}>{chip}</Tooltip>;
}

export default OriginChip;
